import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { Flex, SvgIcon, Text } from 'Components/Base';
import useCompatibleDisplay from 'Util/Hooks/useCompatibleDisplay';

const ThumbnailCardWrapper = styled(Flex)`
  padding: 40px;
  background: ${({ theme }) => theme.colors.guidedPractice.thumbnailCardBackground};
  grid-row-gap: 20px;
  border-radius: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex: 1;
`;

const ThumbnailCard = (props) => {
  const { title, description, icon, ...restProps } = props;
  const { isMobile } = useCompatibleDisplay();
  return (
    <ThumbnailCardWrapper data-testid={'thumbnail-card'} {...restProps}>
      {icon && <SvgIcon icon={icon} size={isMobile ? 88 : 96} />}
      <Flex flexDirection={'column'} gridRowGap={2}>
        {title && (
          <Text color={'primary'} textStyle={isMobile ? 'heading4' : 'heading3'} lineHeight={1.6}>
            {title}
          </Text>
        )}
        {description && (
          <Text textStyle={'subtitle1'} fontWeight={400} lineHeight={1.6}>
            {description}
          </Text>
        )}
      </Flex>
    </ThumbnailCardWrapper>
  );
};

ThumbnailCard.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  icon: PropTypes.func,
};

export default ThumbnailCard;
